import { render } from "./PartnersComponent.vue?vue&type=template&id=43154ef9"
import script from "./PartnersComponent.vue?vue&type=script&lang=js"
export * from "./PartnersComponent.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__